"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _link = require("../link");
var _date = require("../date");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * FooterLegal is a component that renders a Legal footer at the bottom of a
 * page.
 */
const FooterLegal = _ref => {
  let {
    crn,
    privacy_policy_url,
    sitemap,
    terms_of_use_url,
    targetBlank
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("section", {
    className: "mm-footer",
    "aria-label": "legal footer"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container mm-footer-legal"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-logo",
    role: "img",
    "aria-label": "MassMutual Logo"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react.default.createElement("p", null, "\xA9", (0, _date.currentYearHandler)(), " Massachusetts Mutual Life Insurance Company (MassMutual\xAE), Springfield, MA 01111-0001. All rights reserved.")), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/_react.default.createElement("ul", null, sitemap && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: (0, _link.absolute)({
      url: sitemap
    }),
    rel: "noopener noreferer",
    target: `${targetBlank ? '_blank' : '_self'}`
  }, "Sitemap")), terms_of_use_url && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: (0, _link.absolute)({
      url: terms_of_use_url
    }),
    rel: "noopener noreferer",
    target: `${targetBlank ? '_blank' : '_self'}`
  }, "Terms of Use")), privacy_policy_url && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement("a", {
    href: (0, _link.absolute)({
      url: privacy_policy_url
    }),
    rel: "noopener noreferer",
    target: `${targetBlank ? '_blank' : '_self'}`
  }, "Privacy"))), crn && /*#__PURE__*/_react.default.createElement("p", null, crn)))));
};
var _default = exports.default = FooterLegal;
FooterLegal.propTypes = {
  /**
   * Compliance Requirement Number is an identified distributed by the Legal team that identifies page content.
   */
  crn: _propTypes.default.string,
  /**
   * The URL to the company or product's Privacy Policy.
   */
  privacy_policy_url: _propTypes.default.string,
  /**
   * The URL to the company or product's sitemap page.
   */
  sitemap: _propTypes.default.string,
  /**
   * The URL to the company or product's Terms of Use page.
   */
  terms_of_use_url: _propTypes.default.string,
  /**
   * All footer links will open in new tab when set to true.
   */
  targetBlank: _propTypes.default.bool
};
FooterLegal.defaultProps = {
  crn: '',
  privacy_policy_url: 'https://www.massmutual.com/legal/privacy',
  sitemap: 'https://www.massmutual.com/sitemap',
  terms_of_use_url: 'https://www.massmutual.com/legal/terms-of-use',
  targetBlank: false
};